var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcIncBreak({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 3.5C1.75268 2.90152 3.11305 2.56142 4.5 2.5C6.5 2.5 7.5 4 9.5 4C10.8869 3.93858 12.2473 3.59848 13.5 3L11.5 2",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 7.5C1.75268 6.90152 3.11305 6.56142 4.5 6.5C6.5 6.5 7.5 8 9.5 8C10.8869 7.93858 12.2473 7.59848 13.5 7L11.5 6",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 11.5C1.75268 10.9015 3.11305 10.5614 4.5 10.5C6.5 10.5 7.5 12 9.5 12C10.8869 11.9386 12.2473 11.5985 13.5 11L11.5 10",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcIncBreak);
export default __webpack_public_path__ + "static/media/ic-inc-break.c403ffc370bf151337053f723b909c5d.svg";
export { ForwardRef as ReactComponent };